export default function getResource(label, vars = []) {
    const resources = {
        marketingTitle: 'Sélectionnez un pays et une langue pour recevoir les mises à jour.',
        marketingLanguage: 'Langue choisie pour le contenu marketing',
        zipCode: 'Code postal',
        postalCode: 'Code postal',
        zipCodeLabel: 'Code postal :',
        postalCodeLabel: 'Code postal :',
        none: 'Aucune',
        enterZipCode: 'Saisissez votre code ZIP afin d’en savoir plus sur les événements en magasin près de chez vous.',
        enterPostalCode: 'Saisissez votre code postal afin d’en savoir plus sur les événements en magasin près de chez vous.',
        usEnglish: 'É.-U. – Anglais',
        canadaEnglish: 'Canada – Anglais',
        canadaFrench: 'Canada – Français',
        pleaseEnterZipCode: 'Veuillez entrer un code postal valide.',
        pleaseEnterPostalCode: 'Veuillez entrer un code postal.',
        invalidZipCode: 'Le code postal est invalide. Veuillez essayer de nouveau.',
        invalidPostalCode: 'Veuillez entrer un code postal valide.',
        cancel: 'Annuler',
        save: 'Enregistrer',
        edit: 'Modifier',
        noCountryOrLanguageSelected: 'Aucun pays ni aucune langue sélectionnés.',
        canadaLangCountryCopy: 'Sephora Beauty Canada, Inc. (160 Bloor St. East Suite 1100 Toronto, ON M4W 1B9 | Canada, sephora.ca) demande le consentement en son propre nom et au nom de Sephora USA, Inc. (350 Mission Street, Floor 7, San Francisco, CA 94105, sephora.com). Vous pouvez retirer votre consentement en tout temps.',
        resubscribeToTextUpdates: 'By changing your marketing language, you will have to resubscribe to text updates.',
        unsubscribedFromSMS: 'You were unsubscribed from SMS marketing. Subscribe again to receive texts in',
        dismiss: 'Dismiss',
        subscribe: 'Subscribe'
    };
    return resources[label];
}
